import { HttpErrorResponse } from '@angular/common/http';

import { DpHttpErrorResponse } from '@app/core/types/http-error-response.interface';

export const isDpHttpError = (error: HttpErrorResponse | DpHttpErrorResponse): boolean =>
  error?.error?.errors !== undefined;
